import styled from "styled-components";
import * as mediaQuery from "components/MediaQuery";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import {
  collapsedSidebarWidth,
  discollapsedSidebarWidth,
} from "components/blocks/sidenav/SideNavBarStyled";
import { InnerPX } from "components/atoms/inner/InnerContainer";

export const Row = styled.div`
  ${FLEX.FlexStartStart};
  gap: 8px;
`;

export const AccountPage = styled.div`
  &._account_staging_assign .table-template-content {
    ${mediaQuery.isMobile} {
      padding: 0;
    }
  }
  &._account_staging .tabs-wrapper + div {
    ${mediaQuery.isMobile} {
      display: none;
    }
  }
`;
export const AssignContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  min-height: calc(100dvh - 178px);
  ${mediaQuery.isTablet} {
    grid-template-columns: 50px 1fr;
  }
  ${mediaQuery.isMobile} {
    grid-template-columns: 1fr;
    grid-template-rows: min-content 1fr;
  }
`;

export const AssignStepBarItem = styled.li<{
  $completed: boolean;
  $current: boolean;
}>`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  color: ${({ $completed, $current, theme }) =>
    !$completed && !$current ? `${COLORS.BLACK}80` : theme.COLORS.SELECTED};
  position: relative;
  span {
    font-size: ${calcRem(14)};
    font-weight: 500;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    ${FLEX.FlexCenterCenter};
    color: ${({ theme }) => theme.COLORS.WHITE};
    background-color: transparent;
    border: 1px solid
      ${({ theme }) =>
        theme.value === "light" ? COLORS.BLACK : COLORS.WHITE}80;
    ${({ $completed, theme }) =>
      $completed &&
      `
      background-color: ${theme.COLORS.SELECTED};
      color: ${theme.value === "light" ? COLORS.WHITE : COLORS.BLACK};
      border: 1px solid ${theme.COLORS.SELECTED};
    `}
    ${({ $current, theme }) =>
      $current &&
      `
      color: ${theme.COLORS.SELECTED};
      border: 1px solid ${theme.COLORS.SELECTED};
    `}
    cursor: pointer;
  }
  b {
    color: ${({ theme, $completed, $current }) =>
      $completed || $current ? theme.COLORS.SELECTED : theme.COLORS.WHITE};
    font-size: ${calcRem(16)};
    ${mediaQuery.isTablet} {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: 10px;
      transform: translateY(-50%);
      font-size: ${calcRem(14)};
      display: none;
      background-color: ${COLORS.WHITE};
      padding: 5px 10px;
      border-radius: 10px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
    ${mediaQuery.isMobile} {
      display: block;
      background: transparent;
      box-shadow: none;
      position: static;
      transform: none;
      margin: 0;
    }
  }
  ${mediaQuery.isTablet} {
    &:hover {
      b {
        display: block;
      }
    }
    flex-direction: column;
    gap: 5px;
  }
`;

export const AssignStepBar = styled.ul`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 30px;
  padding-top: 40px;
  ${mediaQuery.isMobile} {
    flex-direction: row;
    ${FLEX.FlexBetweenCenter};
    gap: 10px;
    padding: 10px 0 5px;
  }
`;
export const AssignComplete = styled.div`
  ${FLEX.FlexBetweenCenter};
  gap: 60px;
  padding: 20px;
  max-width: 700px;
  margin: 0 auto;
  border: 1px solid ${({ theme }) => theme.COLORS.SELECTED};
  background-color: ${({ theme }) =>
    theme.value === "light"
      ? `${theme.COLORS.SELECTED}06`
      : `${theme.COLORS.SELECTED}20`};
  border-radius: 4px;
  margin-top: 40px;
  > div {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 5px;
    font-size: ${calcRem(16)};
    color: ${({ theme }) => theme.COLORS.WHITE};
    flex: 1;
  }
  .email {
    font-size: ${calcRem(13)};
    color: ${({ theme }) => theme.COLORS.WHITE}60;
  }
`;
export const AssignButtonWrapper = styled.div<{ isCollapsed: boolean }>`
  ${FLEX.FlexBetweenCenter};
  gap: 10px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: ${({ isCollapsed }) =>
    isCollapsed
      ? `${discollapsedSidebarWidth + 200 + InnerPX}px`
      : `${collapsedSidebarWidth + 200 + InnerPX}px`};
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : theme.COLORS.PRIMARY2};
  border: solid
    ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.LIGHTGRAYBORDER
        : theme.COLORS.PRIMARY3};
  border-width: 1px 0 0 1px;
  padding: 20px ${InnerPX}px;
  ${mediaQuery.isTablet} {
    left: ${({ isCollapsed }) =>
      isCollapsed
        ? `${discollapsedSidebarWidth + 50 + InnerPX / 2}px`
        : `${collapsedSidebarWidth + 50 + InnerPX / 2}px`};
    padding: 20px ${InnerPX / 2}px;
  }
  ${mediaQuery.isMobile} {
    left: 0;
    right: 0;
    padding: 10px;
    button {
      width: auto;
    }
  }
`;
export const AssignButton = styled.button`
  border-radius: 2px;
  font-size: ${calcRem(16)};
  ${FLEX.FlexCenterCenter};
  gap: 7px;
  cursor: pointer;
`;
export const AssignCompleteSeparator = styled.span`
  ${FLEX.FlexCenterCenter};
  gap: 10px;
  background-color: ${({ theme }) => theme.COLORS.SELECTED}20;
  color: ${({ theme }) => theme.COLORS.SELECTED};
  width: 38px;
  height: 38px;
  border-radius: 50%;
  font-size: ${calcRem(20)};
`;
export const AssignContent = styled.div<{ $page: number }>`
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : COLORS.PRIMARY2};
  padding: 0 ${InnerPX}px 82px;
  margin-right: -${InnerPX}px;
  ${mediaQuery.isTablet} {
    margin-right: -${InnerPX / 2}px;
    padding: 0 ${InnerPX / 2}px 82px;
  }
  border-left: 1px solid
    ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.LIGHTGRAYBORDER
        : theme.COLORS.PRIMARY3};
  .ant-table-content {
    min-height: 0;
    ${({ $page }) =>
      $page === 2 &&
      `
      max-width: 700px;
      margin: 0 auto;
    `}
  }
  .ant-table-selection-column .ant-radio-wrapper-disabled {
    opacity: 0;
    visibility: hidden;
  }
  .subheader {
    padding: 10px 0 0;
    ${({ $page }) =>
      $page === 2 &&
      `
      max-width: 700px;
      margin: 0 auto;
    `}
    .routes-mark-wrapper {
      display: none;
    }
    .title-component-title {
      font-size: ${calcRem(18)};
    }
  }
  ${mediaQuery.isMobile} {
    margin-right: 0;
    padding: 0 10px;
  }
`;
